import React, { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";
import LogOut from "../MSAL/LoginRedirect";
import { loginRequest } from "../MSAL/authConfig";
import { useMsal } from "@azure/msal-react";
import { callMsGraph } from "../MSAL/graph";

//import { session } from '../functions/SurveyFunction';

//redux
import { useDispatch, useSelector } from 'react-redux'
import { getSesion } from '../store/slices/sesion'
import Load from '../extra/Load'
import { Grid } from '@mui/material';
import Formulario from '../components/formulario';
import { getDatosCae } from '../store/slices/datosCae';
import { getAvance } from '../store/slices/avance';
import { getArchiv } from '../store/slices/archiv';
import AccesoDenegado from "../components/AccesoDenegado"
import AccesoDenegadoFinProceso from "../components/AccesoDenegadoFinProceso"



const PrivateRoutes = () => {
    const { instance, accounts } = useMsal();
    const [load, setLoad] = useState(true)
    const [info, setInfo] = useState(false)
    //redux
    const dispatch = useDispatch()
    const state = useSelector(state => state.sesion) //se llama al reducer por nombre { name: 'session' }
    const { datosCae } = useSelector(state => state.datosCae)






    useEffect(() => {
        Promise.all([
            dispatch(getSesion(accounts)),
            dispatch(getDatosCae(accounts)),
        ]).then((response) => {


            if (response[1] && response[1].data && response[1].data.length > 0) {
                setInfo(true)


            Promise.all([
                dispatch(getAvance({ rut_estudiante: response[1].data[0].rut, carrera_estudiante: response[1].data[0].CodCarr })),
                dispatch(getArchiv({ rut_estudiante: response[1].data[0].rut, tipo_proceso: 'CAE' }))
            ])
                .finally(() => {
                    setLoad(false)
                })
            } else{
                setLoad(false)

            }
        }).catch((error) => {
            console.error('Error al cargar datos:', error)
            setLoad(false)
        })
    }, [])


    if (load) {


        return  <Load /> 


    } else {
 

        const Renderizado = () => (
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                xs={12}
            >
                <Routes>
                    <Route exact path="/" element={<Formulario />} />

                </Routes>

            </Grid>

        )






        const mensajeError = () => (
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                xs={12}

            >


                <Grid
                    item
                    xs={12}
                    md={12}

                >



                    <Routes>
                        <Route exact path="/" element={<AccesoDenegado />} />
                    </Routes>

                </Grid>
            </Grid>
        )


     
        const mensajeErrorFinProceso = () => (
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                xs={12}

            >


                <Grid
                    item
                    xs={12}
                    md={12}

                >



                    <Routes>
                        <Route exact path="/" element={<AccesoDenegadoFinProceso />} />
                    </Routes>

                </Grid>
            </Grid>
        )

        if(state.estudiante.inicioCierre.length == 0 ) return  mensajeErrorFinProceso()

        return (info == true )  ? Renderizado() :  mensajeError();

        // switch (info) {

        //     case  true :
        //         return Renderizado();

        //     default:
        //         return mensajeError();
        // }


    }
};

export default PrivateRoutes





